import { render } from "./Index.vue?vue&type=template&id=48134f40&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=48134f40&scoped=true&lang=css"

import exportComponent from "C:\\ZYSRC\\FW\\fwm_web_jinmixi-master -ybq\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48134f40"]])

export default __exports__